/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Error/view.blocks to change it.
import "DesignSystem/Fonts/Inter-300.css"
import Info from 'DesignSystem/Info/index'
import NoSearchResult from 'DesignSystem/Images/NoSearchResult/index'
import React from 'react'
import SupportLink from './SupportLink/index'
import TagLabel from 'DesignSystem/TagLabel/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'



/** @type {import('Simple/types.js').View} */
export default function Error({
  children,
  viewPath = "/App/Account/Search/Content/Profiles/Error"
  
}) {
  let isBefore = useIsBefore()
  return (<React.Fragment
>
<div
  data-testid="Error.Vertical"
  data-view-path={viewPath}
 style={{'--o-1-4QcjJ': isBefore ? 0 : 1}}
 className={`views-block ${styles.Vertical}`}
>
<NoSearchResult
  viewPath={`${viewPath}/NoSearchResult`}
 width={150}
 height="auto"
/>
<span
  data-testid="Error.Text"
  data-view-path={viewPath}
 className={`views-text ${styles.Text}`}
>
No matches found
</span>
<Info
  viewPath={`${viewPath}/Info`}
 marginTop={4}
 text="Try these formats to refine your search:"
/>
<div
  data-testid="Error.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<TagLabel
  viewPath={`${viewPath}/TagLabel`}
 tagText="MM/DD/YYYY"
 labelText="Date of birth"
/>
<TagLabel
  viewPath={`${viewPath}/TagLabel`}
 marginTop={4}
 tagText="(123) 123-1234"
 labelText="Phone number"
/>
<TagLabel
  viewPath={`${viewPath}/TagLabel`}
 marginTop={4}
 tagText="john@abcd.com"
 labelText="Email"
/>
<TagLabel
  viewPath={`${viewPath}/TagLabel`}
 marginTop={4}
 tagText="1234a"
 labelText="Greyfinch person ID"
/>
<TagLabel
  viewPath={`${viewPath}/TagLabel`}
 marginTop={4}
 tagText="111-22-3333"
 labelText="SSN"
/>
<TagLabel
  viewPath={`${viewPath}/TagLabel`}
 marginTop={4}
 tagText="W123456789"
 labelText="Member ID"
/>
</div>
<SupportLink
  viewPath={`${viewPath}/SupportLink`}
/>
</div>
{children}
</React.Fragment>)
}